import MundHelpGrid from "../icons/MundHelpGrid";
import HelpGridIcon from "../icons/HelpGrid";
import IntegrationTable from "@/components/shared/IntegrationTable/IntegrationTable";
import { integrationFieldPresets } from "@/components/shared/IntegrationTable/integrationFieldPresets";
import { useTranslation } from "react-i18next";

export default function HelpGrid() {
  const { t } = useTranslation("integration");

  return (
    <IntegrationTable
      integrationKey='helpgrid'
      title='HelpGrid'
      main_icon={<MundHelpGrid />}
      icon={<HelpGridIcon />}
      fields={[
        integrationFieldPresets.postback_url,
        integrationFieldPresets.access_token,
        integrationFieldPresets.secret_token,
        integrationFieldPresets.status,
      ]}
      fixedOptions={{
        active_statuses: [
          "not_authorized",
          "abandoned_cart",
          "awaiting_payment",
          "failed",
        ],
      }}
      fieldLabels={{
        access_token: t("helpgrid_ipn_key"),
        placeholder_access_token: t("helpgrid_placeholder_ipn_key"),
        secret_token: t("helpgrid_account_uid"),
        placeholder_secret_token: t("helpgrid_placeholder_account_uid"),
        postback_url: t("helpgrid_url"),
        placeholder_postback_url: t("helpgrid_placeholder_url"),
      }}
    />
  );
}
